<!-- Read on every render, even with no section listed, so a section that drops out is forgotten. -->
@let expandedKeys = openSectionKeys();
@if (itemCount() > 0 || sections().hiddenCount > 0) {
  <sidebar-header
    [title]="title()"
    [indicator]="itemCount()"
    class="block border-0 border-b-2 border-solid border-default"
  />
  @for (group of sections().groups; track group.departmentId) {
    <ng-container *ngTemplateOutlet="departmentSection; context: { $implicit: group }" />
  }
  @if (sections().hiddenCount; as hiddenCount) {
    @let otherContentId = idPrefix + '-other-departments';
    @let hiddenTextId = idPrefix + '-hidden-count';
    <div class="flex items-center gap-sm border-0 border-b border-solid border-default p-sm text-sm text-subtle">
      <span class="flex min-w-0 items-center gap-2xs">
        <sb-icon name="filter-2-regular" size="sm" class="shrink-0" aria-hidden="true" />
        <span [id]="hiddenTextId">{{ '[count] hidden by department filter' | translate: { count: hiddenCount } }}</span>
      </span>
      <button
        type="button"
        class="reset-button shrink-0 cursor-pointer rounded-sm px-2xs font-semibold text-brand hover:text-brand-hover"
        [attr.aria-expanded]="showOtherDepartments()"
        [attr.aria-controls]="otherContentId"
        [attr.aria-describedby]="hiddenTextId"
        (click)="showOtherDepartments.set(!showOtherDepartments())"
      >
        @if (showOtherDepartments()) {
          {{ 'Hide' | translate }}
        } @else {
          {{ 'Show' | translate }}
        }
      </button>
    </div>
    <div [id]="otherContentId">
      @if (showOtherDepartments()) {
        @for (group of sections().otherGroups; track group.departmentId) {
          <ng-container *ngTemplateOutlet="departmentSection; context: { $implicit: group }" />
        }
      }
    </div>
  }
  @if (noDepartmentGroup(); as group) {
    <ng-container *ngTemplateOutlet="departmentSection; context: { $implicit: group }" />
  }
}

<ng-template #departmentSection let-group>
  @let expanded = expandedKeys.has(group.departmentId);
  @let contentId = idPrefix + '-' + group.departmentId;
  @let name = group.name ?? ('No department' | translate);
  @let count = group.items.length;
  @let labelParams = { department: name, location: group.locationName, count: count };
  @let sectionLabel =
    group.locationName
      ? count === 1
        ? ('[department], [location], 1 request' | translate: labelParams)
        : ('[department], [location], [count] requests' | translate: labelParams)
      : count === 1
        ? ('[department], 1 request' | translate: labelParams)
        : ('[department], [count] requests' | translate: labelParams);
  <h4 class="reset-h px-sm pt-sm pb-xs text-sm font-bold text-subtle">
    <button
      type="button"
      class="reset-button flex w-full min-w-0 cursor-pointer items-center gap-xs rounded-sm p-2xs text-left"
      [attr.aria-expanded]="expanded"
      [attr.aria-controls]="contentId"
      [attr.aria-label]="sectionLabel"
      (click)="toggleSection(group.departmentId)"
    >
      <sb-icon [name]="expanded ? 'down-regular' : 'right-regular'" size="sm" aria-hidden="true" />
      <span class="min-w-0 truncate tracking-wide uppercase" [title]="group.label ?? name">{{ name }}</span>
      <span class="ml-xs shrink-0 font-normal text-default">{{ count }}</span>
      @if (group.locationName) {
        <span class="ml-auto max-w-1/2 min-w-0 truncate pl-sm font-normal text-default">{{ group.locationName }}</span>
      }
    </button>
  </h4>
  <div [id]="contentId">
    @if (expanded) {
      <ng-container *ngTemplateOutlet="rows(); context: { $implicit: group }" />
    }
  </div>
</ng-template>
